import axios from "@/plugins/axios";

let url = "/api/v1/technicians";

export default {
    getTechnicians(data){
        return axios.get(url, data).then(result => result.data);
    },
    getTechnician(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
}
